// import components
import { showSnackbar } from '../components/shared';

// import hooks
import { useCallback } from 'react';
import { useMutation, useQueryClient } from 'react-query';

// import types
import { AxiosError, AxiosResponse } from 'axios';
import { UseCreateResourceParams } from './useCreateResource.types';

// import utils
import axios from 'axios';
import i18n from 'i18next';
import { replaceUrlParams } from 'components/employee-portal/travel-arrangements/utils';

export const useCreateResource = <D = any, T = any, R = AxiosResponse<T>>({
  url,
  params,
  invalidateQueryKey,
  message
}: UseCreateResourceParams) => {
  const create = useCallback(
    (data) => {
      const finalUrl = replaceUrlParams(url, params || {});
      return axios.post<T, R, D>(finalUrl, data);
    },
    [url, params]
  );

  const queryClient = useQueryClient();

  return useMutation<R, AxiosError, D>(create, {
    onSuccess: async (response) => {
      if (invalidateQueryKey) {
        await queryClient.invalidateQueries({
          queryKey: invalidateQueryKey
        });
      }
      showSnackbar({
        severity: 'success',
        message: message?.success ?? i18n.t('changesSaved')
      });
      return response;
    }
  });
};
